import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['cancelAndAnswer','sendAnswer']
  toggleInputs() {
    this.cancelAndAnswerTarget.hidden = !this.cancelAndAnswerTarget.hidden
    this.sendAnswerTarget.hidden = !this.sendAnswerTarget.hidden
  }
}
